import "core-js/modules/esnext.global-this.js";
import "core-js/modules/es.array.sort.js";
import * as e from "react";
import t from "react";
import r from "prop-types";
import n from "invariant";
function o() {
  return o = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, o.apply(this, arguments);
}
function a(e, t) {
  if (null == e) return {};
  var r,
    n,
    o = {},
    a = Object.keys(e);
  for (n = 0; n < a.length; n++) t.indexOf(r = a[n]) >= 0 || (o[r] = e[r]);
  return o;
}
const s = e => {
    const {
      search: t,
      hash: r,
      href: n,
      origin: o,
      protocol: a,
      host: s,
      hostname: i,
      port: c
    } = e.location;
    let {
      pathname: l
    } = e.location;
    return !l && n && u && (l = new URL(n).pathname), {
      pathname: encodeURI(decodeURI(l)),
      search: t,
      hash: r,
      href: n,
      origin: o,
      protocol: a,
      host: s,
      hostname: i,
      port: c,
      state: e.history.state,
      key: e.history.state && e.history.state.key || "initial"
    };
  },
  i = (e, t) => {
    let r = [],
      n = s(e),
      a = !1,
      i = () => {};
    return {
      get location() {
        return n;
      },
      get transitioning() {
        return a;
      },
      _onTransitionComplete() {
        a = !1, i();
      },
      listen(t) {
        r.push(t);
        const o = () => {
          n = s(e), t({
            location: n,
            action: "POP"
          });
        };
        return e.addEventListener("popstate", o), () => {
          e.removeEventListener("popstate", o), r = r.filter(e => e !== t);
        };
      },
      navigate(t) {
        let {
          state: c,
          replace: u = !1
        } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if ("number" == typeof t) e.history.go(t);else {
          c = o({}, c, {
            key: Date.now() + ""
          });
          try {
            a || u ? e.history.replaceState(c, null, t) : e.history.pushState(c, null, t);
          } catch (r) {
            e.location[u ? "replace" : "assign"](t);
          }
        }
        n = s(e), a = !0;
        const l = new Promise(e => i = e);
        return r.forEach(e => e({
          location: n,
          action: "PUSH"
        })), l;
      }
    };
  },
  c = function () {
    let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
    const t = e.indexOf("?"),
      r = {
        pathname: t > -1 ? e.substr(0, t) : e,
        search: t > -1 ? e.substr(t) : ""
      };
    let n = 0;
    const o = [r],
      a = [null];
    return {
      get location() {
        return o[n];
      },
      addEventListener(e, t) {},
      removeEventListener(e, t) {},
      history: {
        get entries() {
          return o;
        },
        get index() {
          return n;
        },
        get state() {
          return a[n];
        },
        pushState(e, t, r) {
          const [s, i = ""] = r.split("?");
          n++, o.push({
            pathname: s,
            search: i.length ? "?".concat(i) : i
          }), a.push(e);
        },
        replaceState(e, t, r) {
          const [s, i = ""] = r.split("?");
          o[n] = {
            pathname: s,
            search: i
          }, a[n] = e;
        },
        go(e) {
          const t = n + e;
          t < 0 || t > a.length - 1 || (n = t);
        }
      }
    };
  },
  u = !("undefined" == typeof window || !window.document || !window.document.createElement),
  l = i(u ? window : c()),
  {
    navigate: p
  } = l;
function h(e, r) {
  return t.createServerContext ? function (e) {
    let r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return globalThis.__SERVER_CONTEXT || (globalThis.__SERVER_CONTEXT = {}), globalThis.__SERVER_CONTEXT[e] || (globalThis.__SERVER_CONTEXT[e] = t.createServerContext(e, r)), globalThis.__SERVER_CONTEXT[e];
  }(e, r) : t.createContext(r);
}
const m = h("Base", {
    baseuri: "/",
    basepath: "/"
  }),
  d = h("Location"),
  f = () => e.useContext(m),
  y = () => e.useContext(d);
function E(e) {
  this.uri = e;
}
const g = e => e instanceof E,
  v = e => {
    throw new E(e);
  };
function b(t) {
  const {
    to: r,
    replace: n = !0,
    state: o,
    noThrow: a,
    baseuri: s
  } = t;
  e.useEffect(() => {
    Promise.resolve().then(() => {
      const e = k(r, s);
      p(P(e, t), {
        replace: n,
        state: o
      });
    });
  }, []);
  const i = k(r, s);
  return a || v(P(i, t)), null;
}
const R = t => {
  const r = y(),
    {
      baseuri: n
    } = f(); /*#__PURE__*/
  return e.createElement(b, o({}, r, {
    baseuri: n
  }, t));
};
R.propTypes = {
  from: r.string,
  to: r.string.isRequired
};
const C = (e, t) => e.substr(0, t.length) === t,
  w = (e, t) => {
    let r, o;
    const [a] = t.split("?"),
      s = N(a),
      i = "" === s[0],
      c = j(e);
    for (let e = 0, a = c.length; e < a; e++) {
      let a = !1;
      const u = c[e].route;
      if (u.default) {
        o = {
          route: u,
          params: {},
          uri: t
        };
        continue;
      }
      const l = N(u.path),
        p = {},
        h = Math.max(s.length, l.length);
      let m = 0;
      for (; m < h; m++) {
        const e = l[m],
          t = s[m];
        if ($(e)) {
          p[e.slice(1) || "*"] = s.slice(m).map(decodeURIComponent).join("/");
          break;
        }
        if (void 0 === t) {
          a = !0;
          break;
        }
        const r = O.exec(e);
        if (r && !i) {
          const e = -1 === U.indexOf(r[1]);
          n(e, "<Router> dynamic segment \"".concat(r[1], "\" is a reserved name. Please use a different name in path \"").concat(u.path, "\"."));
          const o = decodeURIComponent(t);
          p[r[1]] = o;
        } else if (e !== t) {
          a = !0;
          break;
        }
      }
      if (!a) {
        r = {
          route: u,
          params: p,
          uri: "/" + s.slice(0, m).join("/")
        };
        break;
      }
    }
    return r || o || null;
  },
  x = (e, t) => w([{
    path: e
  }], t),
  k = (e, t) => {
    if (C(e, "/")) return e;
    const [r, n] = e.split("?"),
      [o] = t.split("?"),
      a = N(r),
      s = N(o);
    if ("" === a[0]) return L(o, n);
    if (!C(a[0], ".")) {
      const e = s.concat(a).join("/");
      return L(("/" === o ? "" : "/") + e, n);
    }
    const i = s.concat(a),
      c = [];
    for (let e = 0, t = i.length; e < t; e++) {
      const t = i[e];
      ".." === t ? c.pop() : "." !== t && c.push(t);
    }
    return L("/" + c.join("/"), n);
  },
  P = (e, t) => {
    const [r, n = ""] = e.split("?");
    let o = "/" + N(r).map(e => {
      const r = O.exec(e);
      return r ? t[r[1]] : e;
    }).join("/");
    const {
        location: {
          search: a = ""
        } = {}
      } = t,
      s = a.split("?")[1] || "";
    return o = L(o, n, s), o;
  },
  T = (e, t) => {
    const r = e => _(e);
    return N(e).filter(r).sort().join("/") === N(t).filter(r).sort().join("/");
  },
  O = /^:(.+)/,
  _ = e => O.test(e),
  $ = e => e && "*" === e[0],
  S = (e, t) => ({
    route: e,
    score: e.default ? 0 : N(e.path).reduce((e, t) => (e += 4, (e => "" === e)(t) ? e += 1 : _(t) ? e += 2 : $(t) ? e -= 5 : e += 3, e), 0),
    index: t
  }),
  j = e => e.map(S).sort((e, t) => e.score < t.score ? 1 : e.score > t.score ? -1 : e.index - t.index),
  N = e => e.replace(/(^\/+|\/+$)/g, "").split("/"),
  L = function (e) {
    for (var _len = arguments.length, t = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      t[_key - 1] = arguments[_key];
    }
    return e + ((t = t.filter(e => e && e.length > 0)) && t.length > 0 ? "?".concat(t.join("&")) : "");
  },
  U = ["uri", "path"],
  D = (e, t) => {
    const r = Object.keys(e);
    return r.length === Object.keys(t).length && r.every(r => t.hasOwnProperty(r) && e[r] === t[r]);
  },
  M = e => e.replace(/(^\/+|\/+$)/g, ""),
  I = t => r => {
    if (!r) return null;
    if (r.type === e.Fragment && r.props.children) return e.Children.map(r.props.children, I(t));
    if (n(r.props.path || r.props.default || r.type === R, "<Router>: Children of <Router> must have a `path` or `default` prop, or be a `<Redirect>`. None found on element type `".concat(r.type, "`")), n(!!(r.type !== R || r.props.from && r.props.to), "<Redirect from=\"".concat(r.props.from, "\" to=\"").concat(r.props.to, "\"/> requires both \"from\" and \"to\" props when inside a <Router>.")), n(!(r.type === R && !T(r.props.from, r.props.to)), "<Redirect from=\"".concat(r.props.from, " to=\"").concat(r.props.to, "\"/> has mismatched dynamic segments, ensure both paths have the exact same dynamic segments.")), r.props.default) return {
      value: r,
      default: !0
    };
    const o = r.type === R ? r.props.from : r.props.path,
      a = "/" === o ? t : "".concat(M(t), "/").concat(M(o));
    return {
      value: r,
      default: r.props.default,
      path: r.props.children ? "".concat(M(a), "/*") : a
    };
  },
  V = ["innerRef"],
  q = ["to", "state", "replace", "getProps"],
  X = ["key"];
let {
  forwardRef: B
} = e;
void 0 === B && (B = e => e);
const K = () => {},
  A = B((t, r) => {
    let {
        innerRef: n
      } = t,
      s = a(t, V);
    const {
        baseuri: i
      } = f(),
      {
        location: c
      } = y(),
      {
        to: u,
        state: l,
        replace: h,
        getProps: m = K
      } = s,
      d = a(s, q),
      E = k(u, i),
      g = encodeURI(E),
      v = c.pathname === g,
      b = C(c.pathname, g); /*#__PURE__*/
    return e.createElement("a", o({
      ref: r || n,
      "aria-current": v ? "page" : void 0
    }, d, m({
      isCurrent: v,
      isPartiallyCurrent: b,
      href: E,
      location: c
    }), {
      href: E,
      onClick: e => {
        if (d.onClick && d.onClick(e), (e => !e.defaultPrevented && 0 === e.button && !(e.metaKey || e.altKey || e.ctrlKey || e.shiftKey))(e)) {
          e.preventDefault();
          let t = h;
          if ("boolean" != typeof h && v) {
            const e = a(o({}, c.state), X);
            t = D(o({}, l), e);
          }
          p(E, {
            state: l,
            replace: t
          });
        }
      }
    }));
  });
A.displayName = "Link", A.propTypes = {
  to: r.string.isRequired
};
class F extends e.Component {
  constructor() {
    super(...arguments), this.displayName = "ReactUseErrorBoundary";
  }
  componentDidCatch() {
    this.setState({}), this.props.onError(...arguments);
  }
  render() {
    return this.props.children;
  }
}
const W = e.createContext({
  componentDidCatch: {
    current: void 0
  },
  error: void 0,
  setError: () => !1
});
function H(_ref) {
  let {
    children: t
  } = _ref;
  const [r, n] = e.useState(),
    o = e.useRef(),
    a = e.useMemo(() => ({
      componentDidCatch: o,
      error: r,
      setError: n
    }), [r]); /*#__PURE__*/
  return e.createElement(W.Provider, {
    value: a
  }, /*#__PURE__*/e.createElement(F, {
    error: r,
    onError: (e, t) => {
      n(e), null == o.current || o.current(e, t);
    }
  }, t));
}
H.displayName = "ReactUseErrorBoundaryContext";
const z = function (t) {
    var r, n;
    function a(r) {
      /*#__PURE__*/return e.createElement(H, null, /*#__PURE__*/e.createElement(t, o({
        key: "WrappedComponent"
      }, r)));
    }
    return a.displayName = "WithErrorBoundary(".concat(null != (r = null != (n = t.displayName) ? n : t.name) ? r : "Component", ")"), a;
  }(_ref2 => {
    let {
      history: t = l,
      children: r
    } = _ref2;
    const {
        location: n
      } = t,
      [o, a] = e.useState({
        location: n
      }),
      [s] = function (t) {
        const r = e.useContext(W);
        r.componentDidCatch.current = void 0;
        const n = e.useCallback(() => {
          r.setError(void 0);
        }, []);
        return [r.error, n];
      }();
    if (e.useEffect(() => {
      t._onTransitionComplete();
    }, [o.location]), e.useEffect(() => {
      let e = !1;
      const r = t.listen(_ref3 => {
        let {
          location: t
        } = _ref3;
        Promise.resolve().then(() => {
          requestAnimationFrame(() => {
            e || a({
              location: t
            });
          });
        });
      });
      return () => {
        e = !0, r();
      };
    }, []), s) {
      if (!g(s)) throw s;
      p(s.uri, {
        replace: !0
      });
    } /*#__PURE__*/
    return e.createElement(d.Provider, {
      value: o
    }, "function" == typeof r ? r(o) : r || null);
  }),
  G = _ref4 => {
    let {
      children: t
    } = _ref4;
    const r = y();
    return r ? t(r) : /*#__PURE__*/e.createElement(z, null, t);
  },
  J = _ref5 => {
    let {
      url: t,
      children: r
    } = _ref5;
    const n = t.indexOf("?");
    let o,
      a = "";
    return n > -1 ? (o = t.substring(0, n), a = t.substring(n)) : o = t, /*#__PURE__*/e.createElement(d.Provider, {
      value: {
        location: {
          pathname: o,
          search: a,
          hash: ""
        }
      }
    }, r);
  },
  Q = _ref6 => {
    let {
      path: e,
      children: t
    } = _ref6;
    const {
        baseuri: r
      } = f(),
      {
        location: n
      } = y(),
      a = k(e, r),
      s = x(a, n.pathname);
    return t({
      location: n,
      match: s ? o({}, s.params, {
        uri: s.uri,
        path: e
      }) : null
    });
  },
  Y = ["uri", "location", "component"],
  Z = ["children", "style", "component", "uri", "location"],
  ee = t => {
    let {
        uri: r,
        location: n,
        component: s
      } = t,
      i = a(t, Y); /*#__PURE__*/
    return e.createElement(re, o({}, i, {
      component: s,
      uri: r,
      location: n
    }));
  };
let te = 0;
const re = t => {
    let {
        children: r,
        style: n,
        component: s = "div",
        uri: i,
        location: c
      } = t,
      u = a(t, Z);
    const l = e.useRef(),
      p = e.useRef(!0),
      h = e.useRef(i),
      m = e.useRef(c.pathname),
      d = e.useRef(!1);
    e.useEffect(() => (te++, f(), () => {
      te--, 0 === te && (p.current = !0);
    }), []), e.useEffect(() => {
      let e = !1,
        t = !1;
      i !== h.current && (h.current = i, e = !0), c.pathname !== m.current && (m.current = c.pathname, t = !0), d.current = e || t && c.pathname === i, d.current && f();
    }, [i, c]);
    const f = e.useCallback(() => {
      var e;
      "test" !== process.env.NODE_ENV && (p.current ? p.current = !1 : (e = l.current, d.current && e && e.focus()));
    }, []); /*#__PURE__*/
    return e.createElement(s, o({
      style: o({
        outline: "none"
      }, n),
      tabIndex: "-1",
      ref: l
    }, u), r);
  },
  ne = ["location", "primary", "children", "basepath", "baseuri", "component"],
  oe = t => {
    const r = f(),
      n = y(); /*#__PURE__*/
    return e.createElement(ae, o({}, r, n, t));
  };
function ae(t) {
  const {
      location: r,
      primary: n = !0,
      children: s,
      basepath: i,
      component: c = "div"
    } = t,
    u = a(t, ne),
    l = e.Children.toArray(s).reduce((e, t) => {
      const r = I(i)(t);
      return e.concat(r);
    }, []),
    {
      pathname: p
    } = r,
    h = w(l, p);
  if (h) {
    const {
        params: t,
        uri: a,
        route: s,
        route: {
          value: l
        }
      } = h,
      p = s.default ? i : s.path.replace(/\*$/, ""),
      d = o({}, t, {
        uri: a,
        location: r
      }),
      f = e.cloneElement(l, d, l.props.children ? /*#__PURE__*/e.createElement(oe, {
        location: r,
        primary: n
      }, l.props.children) : void 0),
      y = n ? ee : c,
      E = n ? o({
        uri: a,
        location: r,
        component: c
      }, u) : u; /*#__PURE__*/
    return e.createElement(m.Provider, {
      value: {
        baseuri: a,
        basepath: p
      }
    }, /*#__PURE__*/e.createElement(y, E, f));
  }
  return null;
}
const se = () => {
    const e = y();
    if (!e) throw new Error("useLocation hook was used but a LocationContext.Provider was not found in the parent tree. Make sure this is used in a component that is a child of Router");
    return e.location;
  },
  ie = () => {
    throw new Error("useNavigate is removed. Use import { navigate } from 'gatsby' instead");
  },
  ce = () => {
    const e = f();
    if (!e) throw new Error("useParams hook was used but a LocationContext.Provider was not found in the parent tree. Make sure this is used in a component that is a child of Router");
    const t = se(),
      r = x(e.basepath, t.pathname);
    return r ? r.params : null;
  },
  ue = e => {
    if (!e) throw new Error("useMatch(path: string) requires an argument of a string to match against");
    const t = f();
    if (!t) throw new Error("useMatch hook was used but a LocationContext.Provider was not found in the parent tree. Make sure this is used in a component that is a child of Router");
    const r = se(),
      n = k(e, t.baseuri),
      a = x(n, r.pathname);
    return a ? o({}, a.params, {
      uri: a.uri,
      path: e
    }) : null;
  };
export { m as BaseContext, A as Link, G as Location, d as LocationContext, z as LocationProvider, Q as Match, R as Redirect, oe as Router, J as ServerLocation, i as createHistory, c as createMemorySource, l as globalHistory, P as insertParams, g as isRedirect, x as match, p as navigate, w as pick, v as redirectTo, k as resolve, D as shallowCompare, C as startsWith, f as useBaseContext, se as useLocation, y as useLocationContext, ue as useMatch, ie as useNavigate, ce as useParams, T as validateRedirect };